import { defineMessages } from 'react-intl';

const messages = defineMessages({
  inventoryLocationsTabDescription: {
    description: 'Description for the inventory locations tab with locations management and table',
    defaultMessage: 'Create, edit and delete your inventory locations.',
    id: 'fp9PrA',
  },
  addLocationButtonLabel: {
    description: 'Button for adding a new inventory location',
    defaultMessage: 'Add Location',
    id: 'Pw5wHo',
  },
  inventoryLocationActive: {
    description: 'Indicates if an inventory location is active',
    defaultMessage: 'Active',
    id: '+SNVXI',
  },
  warehousesGridHeaderActionsColumn: {
    description: 'Column header for actions dropdown menu in the warehouses grid',
    defaultMessage: 'Actions',
    id: 'y2rVHQ',
  },
  manageLocationsModalGridPlaceholderText: {
    description: 'Informational text when there are no records in the manage locations modal grid',
    defaultMessage: 'There are currently no records',
    id: 'nfuT3s',
  },
  editModalHeader: {
    description: 'Header for the edit location modal',
    defaultMessage: 'Edit Location',
    id: 'OzSqlc',
  },
  newLocationModalHeader: {
    description: 'Header for the new location modal',
    defaultMessage: 'Add New Location',
    id: 'CWe6/v',
  },
  manageLocationsModalGridSaveButton: {
    description: 'Button label for saving changes in the manage locations modal grid',
    defaultMessage: 'Save',
    id: 'IpmQl5',
  },
  manageLocationsModalGridShowInactiveCheckbox: {
    description: 'Checkbox label for showing inactive locations in the manage locations modal grid',
    defaultMessage: 'Show Inactive Locations',
    id: 'RQmU10',
  },
  editLayoutButtonLabel: {
    description: 'Label for the button to edit the layout of the locations table',
    defaultMessage: 'Edit Layout',
    id: '41DEQA',
  },
  selectAllLocations: {
    description: 'Label for the checkbox to select all locations',
    defaultMessage: 'Select all locations',
    id: 'Rrn1S0',
  },
  selectLocation: {
    description: 'Label for the checkbox to select a specific location',
    defaultMessage: 'Select location {locationId}',
    id: '/qsXIN',
  },
  printBarcode: {
    description: 'Button text for printing barcode',
    defaultMessage: 'Print Barcode',
    id: 'wv/1zp',
  },
  downloadBarcode: {
    description: 'Button text for downloading barcode',
    defaultMessage: 'Download Barcode',
    id: 'aJc0Aj',
  },
  deleteButton: {
    description: 'Button text for deleting locations',
    defaultMessage: 'Delete',
    id: '3TIavY',
  },
  deleteLocationsSuccessTitle: {
    description: 'Title for success notification when deleting locations',
    defaultMessage: 'Locations deleted successfully',
    id: 'A2idAE',
  },
  deleteLocationsSuccessContent: {
    description: 'Content for success notification when deleting locations',
    defaultMessage: 'Successfully deleted {count} location(s).',
    id: 'qZGSUi',
  },
  deleteLocationsFailTitle: {
    description: 'Title for error notification when deleting locations fails',
    defaultMessage: 'Failed to delete locations',
    id: 'RXtkq9',
  },
  deleteLocationsFailContent: {
    description: 'Content for error notification when deleting locations fails',
    defaultMessage: 'There was an error deleting the locations. Please try again.',
    id: 'XJWqvP',
  },
  printBarcodesSuccessTitle: {
    description: 'Title for success notification when printing barcodes',
    defaultMessage: 'Barcodes sent to print',
    id: 'p4LWZy',
  },
  printBarcodesSuccessContent: {
    description: 'Content for success notification when printing barcodes',
    defaultMessage: 'Your barcode labels have been sent to print.',
    id: 'f9fJqp',
  },
  printBarcodesErrorTitle: {
    description: 'Title for error notification when printing barcodes fails',
    defaultMessage: 'Failed to print barcodes',
    id: 'PZDyMd',
  },
  printBarcodesErrorMessage: {
    description: 'Content for error notification when printing barcodes fails',
    defaultMessage: 'There was an error printing the barcodes. Please try again.',
    id: 'BFFt0Q',
  },
  importCsv: {
    description: 'Label for the button to import locations via CSV',
    defaultMessage: 'Import via CSV',
    id: 'wke92v',
  },
  generateBarcode: {
    description: 'Button text for generating barcodes for locations without barcodes',
    defaultMessage: 'Generate Barcode',
    id: 'lEZLvh',
  },
  generateBarcodesSuccessTitle: {
    description: 'Title for success notification when generating barcodes',
    defaultMessage: 'Barcodes generated successfully',
    id: 'cwX+Tu',
  },
  generateBarcodesSuccessContent: {
    description: 'Content for success notification when generating barcodes',
    defaultMessage: 'Successfully generated barcodes for {count} location(s).',
    id: 'MlcwAy',
  },
  generateBarcodesErrorTitle: {
    description: 'Title for error notification when generating barcodes fails',
    defaultMessage: 'Failed to generate barcodes',
    id: 'mmPNKI',
  },
  generateBarcodesErrorMessage: {
    description: 'Content for error notification when generating barcodes fails',
    defaultMessage: 'There was an error generating barcodes. Please try again.',
    id: '2BOPhe',
  },
  exportCsv: {
    description: 'Label for the button to export locations to CSV',
    defaultMessage: 'Export to CSV',
    id: 'zt+HRE',
  },
  csvDownloadError: {
    description: 'Error message when CSV download fails',
    defaultMessage: 'Failed to download CSV file. Please try again.',
    id: 'w/PU7X',
  },
});

export default messages;
